import {
  SET_EDITING_TASK_ID,
  SET_TASKLIST_REORDERING_TYPE,
} from 'constants/actions';

const initialState = {
  editingTaskId: null,
  reorderingType: null,
};

export default function taskLists(
  state = initialState,
  { type, taskId, reorderingType },
) {
  switch (type) {
    case SET_EDITING_TASK_ID:
      return {
        ...state,
        editingTaskId: taskId,
      };
    case SET_TASKLIST_REORDERING_TYPE:
      return {
        ...state,
        reorderingType,
      };
    default:
      return state;
  }
}
